import {
  ButtonGroupWrapper,
  FilledButton,
  IconButton,
  OutlinedButton,
} from "@sainsburys-tech/luna-button";
import { CheckboxField, Form, SelectField, TextInputField } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FIELDS, FormInputLevels } from "../../../Interfaces/IDuTypeFormField";
import {
  DuTypeFormProps,
  ILinkedContainerFormValueType,
} from "../../../Types/duTypeFormProps";
import "./duTypeModalAdd.scss";
import { Plus } from "@sainsburys-tech/luna-icons";
import LegacyContainerPopup from "./LegacyContainerPopup";
import { nullToStringConverter } from "../../../helpers/StringHelpersMethods";
import { ILegacyDuTypeFormValueType } from "../../../Types/legacyDuTypeFormProps";
import LinkedContainerPopup from "./LinkedContainerPopup";
import { FieldInfo } from "@sainsburys-tech/luna-form";

const DuTypeForm: FC<DuTypeFormProps> = (props) => {
  const payload = useSelector((state: any) => state.popupReducer);
  const [isOpen, setIsOpen] = useState(false);
  const [isLegacyContainerButtonDisabled, setIsLegacyContainerButtonDisabled] =
    useState(true);
  const [isLinkedContainerButtonDisabled, setIsLinkedContainerButtonDisabled] =
    useState(true);
  const [isContainerAndCustomerDisabled, setIsContainerAndCustomerDisabled] =
    useState(false);
  const [legacyContainers, setLegacyContainers] = useState<
    ILegacyDuTypeFormValueType[]
  >(props.values.legacyContainerDetails || []);
  const [containerProps, setContainerProps] = useState<DuTypeFormProps>(props);

  const [isLinkedContainerPopupOpen, setIsLinkedContainerPopupOpen] =
    useState(false);

  const [linkedContainers, setLinkedContainers] = useState<
    ILinkedContainerFormValueType[]
  >(props.values.linkedContainers || []);

  const numToStringReplacer = (key: any, value: any) => {
    if (typeof value === "number") {
      return value?.toString();
    }
    return value;
  };

  useEffect(() => {
    setLegacyContainers(props.values.legacyContainerDetails || []);
  }, [props.values.legacyContainerDetails]);

  useEffect(() => {
    setContainerProps(props);
  }, [props]);

  useEffect(() => {
    setIsLegacyContainerButtonDisabled(true);
    if (props.values.containerType !== "") {
      setIsLegacyContainerButtonDisabled(false);
    }
  }, [props.values.containerType]);

  useEffect(() => {
    setIsLinkedContainerButtonDisabled(!props.values.mlpIndicator);
  }, [props.values.mlpIndicator]);

  useEffect(() => {
    if (legacyContainers !== undefined && legacyContainers?.length > 0) {
      setIsContainerAndCustomerDisabled(true);
    }
  }, [legacyContainers]);

  useEffect(() => {
    setLinkedContainers(props.values.linkedContainers || []);
  }, [props.values.linkedContainers]);

  // Enable Container & Customer Type
  // Disable Legacy Container
  useEffect(() => {
    if (legacyContainers !== undefined && legacyContainers?.length > 0) {
      //If nothing in legacy container make container type and customertype disabled
      setIsContainerAndCustomerDisabled(true);
      props.onLegacyContainer(legacyContainers);
    } else {
      setIsContainerAndCustomerDisabled(false);
    }
  }, [legacyContainers]);

  const isInitialState =
    JSON.stringify(payload?.data?.editPayload?.values, numToStringReplacer) ===
    JSON.stringify(props.values, numToStringReplacer);

  const onAddViewClick = (event: any) => {
    setIsOpen(!isOpen);
  };
  const closeHandler = (event: any) => {
    setIsOpen(!isOpen);
  };
  const onSubmit = (event: any, data: ILegacyDuTypeFormValueType[]) => {
    setIsOpen(false);
    setLegacyContainers(data as ILegacyDuTypeFormValueType[]);
  };

  const onAddViewLinkedContainerClick = (event: any) => {
    setIsLinkedContainerPopupOpen(true);
  };
  const closeLinkedContainerHandler = (event: any) => {
    setIsLinkedContainerPopupOpen(false);
  };
  const onLinkedContainerSubmit = (
    event: any,
    data: ILinkedContainerFormValueType[]
  ) => {
    setIsLinkedContainerPopupOpen(false);
    setLinkedContainers(data);
    props.onLinkedContainerUpdate(data);
  };

  const onDropDownChange = (e: any) => {
    props.onChange(e);
    setIsLegacyContainerButtonDisabled(true);
    if (e.target.value !== "") {
      setIsLegacyContainerButtonDisabled(false);
    }
  };

  return (
    <>
      <Form className="o-form">
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.containerType.name}
              label={FormInputLevels.CONTAINERTYPE}
              maxLength={10}
              value={props.values.containerType}
              error={props.errors?.containerType}
              onBlur={props.onBlur}
              onChange={props.onChange}
              disabled={props.isEdit}
            />
          </GridItem>
          {/* <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
            <Dropdown
              label={FormInputLevels.CONTAINERTYPE}
              apiPath="dutypemaintenance/dutypemaintenances/PredefinedContainers"
              valueField={"ContainerType"}
              labelField={"Description"}
              placeholder={"Select Container Type"}
              initialValue={""}
              name={FIELDS.containerType.name}
              isEnabled={true}
              onChange={onDropDownChange}
              onSelect={onDropDownSelect}
            />
          </GridItem> */}
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.containerName.name}
              label={FormInputLevels.CONTAINERTNAME}
              maxLength={20}
              value={props.values.containerName}
              error={props.errors?.containerName}
              onBlur={props.onBlur}
              onChange={props.onChange}
              disabled={props.isEdit}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.description.name}
              label={FormInputLevels.DESCRIPTION}
              maxLength={50}
              value={props.values.description}
              error={props.errors?.description}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.weight.name}
              label={FormInputLevels.WEIGHT}
              value={nullToStringConverter(props.values.weight)}
              error={props.errors?.weight}
              onBlur={props.onBlur}
              onChange={(e: any) => {
                props.onChange(e);
              }}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.volume.name}
              label={FormInputLevels.VOLUME}
              value={nullToStringConverter(props.values.volume)}
              error={props.errors?.volume}
              onBlur={props.onBlur}
              onChange={(e: any) => {
                props.onChange(e);
              }}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.fullLength.name}
              label={FormInputLevels.FULLLENGTH}
              value={nullToStringConverter(props.values.fullLength)}
              error={props.errors?.fullLength}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.fullWidth.name}
              label={FormInputLevels.FULLWIDTH}
              value={nullToStringConverter(props.values.fullWidth)}
              error={props.errors?.fullWidth}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.fullHeight.name}
              label={FormInputLevels.FULLHEIGHT}
              value={nullToStringConverter(props.values.fullHeight)}
              error={props.errors?.fullHeight}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.weightCap.name}
              label={FormInputLevels.WEIGTHCAP}
              value={nullToStringConverter(props.values.weightCap)}
              error={props.errors?.weightCap}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.minPickVolume.name}
              label={FormInputLevels.MINPICKVOLUME}
              value={nullToStringConverter(props.values.minPickVolume)}
              error={props.errors?.minPickVolume}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/3", xs: "1" }}>
            <TextInputField
              name={FIELDS.maxPickVolume.name}
              label={FormInputLevels.MAXPICKVOLUME}
              value={nullToStringConverter(props.values.maxPickVolume)}
              error={props.errors?.maxPickVolume}
              onBlur={props.onBlur}
              onChange={props.onChange}
            />
          </GridItem>
        </GridWrapper>
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ md: "1/4", sm: "1/2", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.lpIndicator.name}
              options={[
                {
                  value: "lpIndicator",
                  label: FormInputLevels.LPINDICATOR,
                },
              ]}
              defaultChecked={payload?.data?.editPayload?.values.lpIndicator}
              //defaultChecked={props?.values.lpIndicator}
              error={props.errors?.lpIndicator}
              onChange={props.onChange}
              className="no-wrap"
              outlined
              fullWidth
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/2", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.mlpIndicator.name}
              options={[
                {
                  value: "mlpIndicator",
                  label: FormInputLevels.MLPINDICATOR,
                },
              ]}
              defaultChecked={payload?.data?.editPayload?.values.mlpIndicator}
              //defaultChecked={props?.values.mlpIndicator}
              error={props.errors?.mlpIndicator}
              onChange={props.onChange}
              onBlur={props.onBlur}
              className="no-wrap"
              outlined
              fullWidth
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/2", xs: "1" }}>
            {/* <input
              type="checkbox" 
              id={FIELDS.muIndicator.name}
              name={FIELDS.muIndicator.name}
              value="Bike"
              checked={undefinedToBoolConverter(props?.values.muIndicator)} /> */}
            <CheckboxField
              label={<p></p>}
              name={FIELDS.muIndicator.name}
              options={[
                {
                  value: "muIndicator",
                  label: FormInputLevels.MUINDICATOR,
                },
              ]}
              defaultChecked={payload?.data?.editPayload?.values.muIndicator}
              //defaultChecked={props?.values.muIndicator}
              //checked={props?.values.muIndicator}
              error={props.errors?.muIndicator}
              onChange={props.onChange}
              className="no-wrap"
              outlined
              fullWidth
            />
          </GridItem>
          <GridItem size={{ md: "1/4", sm: "1/2", xs: "1" }}>
            <CheckboxField
              label={<p></p>}
              name={FIELDS.isLinkableContainer.name}
              options={[
                {
                  value: "isLinkableContainer",
                  label: FormInputLevels.ISLINKABLECONTAINER,
                },
              ]}
              defaultChecked={
                payload?.data?.editPayload?.values.isLinkableContainer
              }
              error={props.errors?.isLinkableContainer}
              onChange={props.onChange}
              onBlur={props.onBlur}
              className="no-wrap"
              outlined
              fullWidth
            />
          </GridItem>
        </GridWrapper>

        {/* Cutomer Type */}
        <GridWrapper className="ln-u-push-bottom">
          <GridItem size={{ sm: "1/3", xs: "1" }}>
            <IconButton
              variant="filled"
              label="Add / View Legacy Container"
              className="add"
              //error = {props.errors?.legacyContainerHasValue}
              disabled={isLegacyContainerButtonDisabled}
              onClick={(event) => onAddViewClick(event)}
            >
              <Plus />
            </IconButton>
            {isOpen && (
              <LegacyContainerPopup
                closeHandler={closeHandler}
                onSubmit={onSubmit}
                isOpen={isOpen}
                containerType={props.values.containerType}
                id={props.id}
                //customerType={props.values.customerType}
                legacyContainersData={legacyContainers}
              />
            )}
            {props.errors?.legacyContainerHasValue ? (
              <FieldInfo id="field-info-2" error={true}>
                {props.errors?.legacyContainerHasValue}
              </FieldInfo>
            ) : null}
          </GridItem>
          <GridItem size={{ sm: "1/3", xs: "1" }}>
            <IconButton
              variant="filled"
              label="Add / View Linked Container"
              className="add"
              disabled={isLinkedContainerButtonDisabled}
              onClick={(event) => onAddViewLinkedContainerClick(event)}
            >
              <Plus />
            </IconButton>
            {isLinkedContainerPopupOpen && (
              <LinkedContainerPopup
                closeHandler={closeLinkedContainerHandler}
                onSubmit={onLinkedContainerSubmit}
                isOpen={isLinkedContainerPopupOpen}
                linkedContainersData={linkedContainers}
                currentContainerType={props.values.containerType}
              />
            )}
          </GridItem>
        </GridWrapper>
      </Form>
      {!isOpen && !isLinkedContainerPopupOpen && (
        <div className="ln-u-bg-color-white stickyButtonGroup">
          <ButtonGroupWrapper className="ln-u-hard-top ln-u-push-bottom duButtonGroup">
            <OutlinedButton
              className="duButtonGroup-add"
              onClick={(event) => props.onCancel()}
              type="button"
            >
              Cancel
            </OutlinedButton>
            <FilledButton
              className="duButtonGroup-add"
              type="button"
              disabled={isInitialState}
              onClick={(event) => props.onSubmit(event)}
            >
              Save
            </FilledButton>
          </ButtonGroupWrapper>
        </div>
      )}
    </>
  );
};

export default DuTypeForm;
